// extracted by mini-css-extract-plugin
module.exports = {"list":"ErrorList_list__I_H1l"};